<app-card [loading]="(loading$ | async) ?? false">
  <div class="header border-bottom">
    <div class="button-wrapper">
    <button type="button"
            class="button icon-button outlined-button"
            [disabled]="!(hasUnreadVisible$ | async)"
            (click)="onMarkAllAsRead()">
      <app-icon name="ic_eye_open"/>
      {{'notification.markAllAsRead' | translate}}
    </button>
    <button type="button"
            class="button danger-button icon-button"
            (click)="onDeleteAll()">
      <app-icon name="ic_delete"/>
      {{ 'notification.deleteAll.label' | translate }}
    </button>
    </div>
  </div>

  <div class="header">
    <button type="button" class="button icon-button filter-button-mobile" (click)="openFilterDialog()">
      <app-icon name="ic_filter"/>
      {{ 'default.filter' | translate }}
    </button>
  </div>

  <ng-template #filterFields>
    <div class="filter-fields flex gap-2" [formGroup]="filterForm">
      <div class="filter-group">
        <div class="flex">
        @for (levelOption of filterOptions.level; track levelOption.value; let i = $index) {
          <app-input-wrapper [control]="filterForm.controls['level']">
            <input [id]="levelOption.value ?? i" [value]="levelOption.value" type="radio" formControlName="level">
            <label [for]="levelOption.value ?? i">{{ levelOption.label | translate }}</label>
          </app-input-wrapper>
        }
        </div>
      </div>

      <div class="filter-group">
        <div class="flex">
          @for (readStateOption of filterOptions.readState; track readStateOption.value) {
            <app-input-wrapper [control]="filterForm.controls['readState']">
              <input [id]="'readState-' + readStateOption.value"
                     [value]="readStateOption.value"
                     type="radio"
                     formControlName="readState">
              <label [for]="'readState-' + readStateOption.value">{{ readStateOption.label | translate }}</label>
            </app-input-wrapper>
          }
        </div>
      </div>
    </div>
  </ng-template>

  @if (!isFilterDialogOpen) {
    <div class="header filter-desktop">
      <ng-container *ngTemplateOutlet="filterFields" />
    </div>
  }
  <div class="content">
    <table>
      <thead>
      <tr app-notification-item-row [isHeader]="true"></tr>
      </thead>
      <tbody>
        @for (notification of notificationList$ | async; track notification.id) {
          <tr app-notification-item-row [notification]="notification"
              (markAsRead)="onMarkAsRead($event)"></tr>
        } @empty {
          <tr>
            <td colspan="100%">
              {{ 'notification.filter.empty' | translate }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="footer">
    <app-pagination [pageSize]="filterForm.value.pageSize"
                    [totalCount]="totalCount$ | async"
                    [currentPage]="filterForm.value.page"
                    (pageChange)="onChangePage($event)"
                    [loading]="loading$ | async"/>
  </div>
</app-card>
